var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogosFirebase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 70,
    viewBox: "0 0 52 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0029335 56.4383L0.426324 55.8456L20.4499 17.8514L20.4922 17.4491L11.6656 0.869087C10.9257 -0.519745 8.84367 -0.168548 8.60117 1.38621L0.0029335 56.4383Z",
    fill: "#FFC24A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.927 29.9903L33.4992 23.2595L26.925 10.7094C26.301 9.52136 24.5586 9.51777 23.9411 10.7094L20.4286 17.4076V17.978L26.9268 29.9903H26.927Z",
    fill: "#F4BD62"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0029335 56.4383L0.194785 56.2453L0.891993 55.9621L26.5142 30.435L26.8389 29.5513L20.4471 17.3713L0.0029335 56.4383Z",
    fill: "#F6820C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7479 69.3122L50.9366 56.3798L44.3147 15.5973C44.1075 14.3213 42.5422 13.817 41.6288 14.7318L0.0029335 56.4384L23.0587 69.3112C23.7753 69.7113 24.5824 69.9215 25.4031 69.9216C26.2239 69.9218 27.0311 69.712 27.7479 69.3122Z",
    fill: "#FDE068"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7288 56.2712L44.1572 15.7984C43.9518 14.532 42.6499 14.0081 41.7435 14.9162L0.260201 56.3589L23.0628 69.1041C23.774 69.5012 24.5749 69.7098 25.3894 69.71C26.204 69.7102 27.005 69.502 27.7164 69.1053L50.729 56.271L50.7288 56.2712Z",
    fill: "#FCCA3F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7477 68.931C27.0309 69.3308 26.2238 69.5405 25.403 69.5404C24.5823 69.5402 23.7753 69.3301 23.0587 68.93L0.188606 56.2423L0.00313568 56.4383L23.0587 69.3111C23.7753 69.7112 24.5824 69.9214 25.4031 69.9215C26.2239 69.9217 27.0311 69.7119 27.7479 69.3121L50.9366 56.3797L50.8798 56.0303L27.7479 68.9312L27.7477 68.931Z",
    fill: "#EEAB37"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosFirebase);
export default __webpack_public_path__ + "static/media/logos_firebase.0dc5e093a55e36587ee0efc179e2f5a6.svg";
export { ForwardRef as ReactComponent };